export enum YeastBrands {
  Enartis = 'Enartis',
  Eaton = 'Eaton',
  Fermentis = 'Fermentis',
  Lallemand = 'Lallemand',
  Erbsloh = 'Erbslöh',
  Oenobrands = 'Oenobrands',
  RedStar = 'Red Star',
  Siha = 'SIHA',
  Enoferm = 'Enoferm',
  ABBiotekMaury = 'AB Biotek / Maury',
  Phibro = 'Phibro',
  Other = 'Other',
}
